import Nullstack from 'nullstack';
export default function IconLogicXor({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-logic-xor",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M22 12h-4"
  }), "   ", Nullstack.element("path", {
    d: "M2 9h6"
  }), "   ", Nullstack.element("path", {
    d: "M2 15h6"
  }), "   ", Nullstack.element("path", {
    d: "M7 19c1.778 -4.667 1.778 -9.333 0 -14"
  }), "   ", Nullstack.element("path", {
    d: "M10 5c10.667 2.1 10.667 12.6 0 14c1.806 -4.667 1.806 -9.333 0 -14z"
  }), " ");
}